export default __webpack_public_path__ + "static/media/resume.85e1494c.svg";